"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSubmitWebBlConsigneeCertification = cancelSubmitWebBlConsigneeCertification;
exports.deletehWebBlConsigneeCertification = deletehWebBlConsigneeCertification;
exports.downFRForm = downFRForm;
exports.downLoadBLIssueForm = downLoadBLIssueForm;
exports.getExportHistory = getExportHistory;
exports.getJpInfo = getJpInfo;
exports.getQueryListHistory = getQueryListHistory;
exports.loadBookingHeadWebInitProps = loadBookingHeadWebInitProps;
exports.saveApplyBookingHeadWebs = saveApplyBookingHeadWebs;
exports.saveCancelBookingHeadWeb = saveCancelBookingHeadWeb;
exports.saveOrUpdateBookingHeadWeb = saveOrUpdateBookingHeadWeb;
exports.saveOrUpdateByTsVoyage = saveOrUpdateByTsVoyage;
exports.saveOrUpdateByVoyage = saveOrUpdateByVoyage;
exports.saveWebBlConsigneeCertification = saveWebBlConsigneeCertification;
exports.searchWebBlConsigneeCertification = searchWebBlConsigneeCertification;
exports.submithWebBlConsigneeCertification = submithWebBlConsigneeCertification;
var _request = _interopRequireDefault(require("@/utils/request"));
function getQueryListHistory(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/queryListHistory',
    // url: '/webBlConsigneeCertification/add',
    method: 'get',
    params: data
  });
}
function getExportHistory(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webBookingHead/exportHistory',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
function loadBookingHeadWebInitProps(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/loadBookingHeadWebInitProps/' + id,
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function getJpInfo() {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/getJpInfo',
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function saveOrUpdateByVoyage(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/saveOrUpdateByVoyage',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
/**
 * 修改保存
 * 订舱历史(日本)，修改，保存草稿
 * 订舱历史(日本)，修改，提交
 * */
function saveOrUpdateBookingHeadWeb(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/saveOrUpdateBookingHeadWeb',
    method: 'post',
    data: data
  });
}
function saveOrUpdateByTsVoyage(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/saveOrUpdateByTsVoyage',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
function saveApplyBookingHeadWebs(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/saveApplyBookingHeadWebs',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
function saveCancelBookingHeadWeb(id) {
  return (0, _request.default)({
    url: '/ebusiness/webBookingHead/saveCancelBookingHeadWeb/' + id,
    // url: '/webBlConsigneeCertification/add',
    method: 'get'
  });
}
function searchWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/search',
    // url: '/webBlConsigneeCertification/search',
    method: 'get',
    params: data
  });
}
function deletehWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/deleteBatch',
    // url: '/webBlConsigneeCertification/deleteBatch',
    method: 'post',
    data: data
  });
}
function saveWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/edit',
    // url: '/webBlConsigneeCertification/edit',
    method: 'post',
    data: data
  });
}
function submithWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/submit',
    // url: '/webBlConsigneeCertification/submit',
    method: 'post',
    data: data
  });
}
function cancelSubmitWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/cancelSubmit',
    // url: '/webBlConsigneeCertification/cancelSubmit',
    method: 'post',
    data: data
  });
}

// 下载对应的FR
function downLoadBLIssueForm(data) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webBookingHead/downLoadBLIssueForm',
    method: 'post',
    data: data
  });
}

// 下载对应的FR
function downFRForm(id) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webBookingHead/downLoadFreightMemo/' + id,
    method: 'get'
  });
}